import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * Do not show cookie banner for a certain page, e.g. the login page.
 */
var preDecisionGatewayHasPageClass = function preDecisionGatewayHasPageClass(classNames) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var className;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            className = document.body.className;
            return _context.abrupt("return", classNames.filter(function (c) {
              return className.indexOf(c) > -1;
            }).length > 0 ? "consent" : false);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

export { preDecisionGatewayHasPageClass };